import React from 'react';

const userContext = React.createContext({ user: {} });

export { userContext };